/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { imagePostImageSpeechless } from "../../funcs/imagePostImageSpeechless.js";
import { PostImageSpeechlessRequest$zodSchema } from "../../models/postimagespeechlessop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: PostImageSpeechlessRequest$zodSchema,
};

export const tool$imagePostImageSpeechless: ToolDefinition<typeof args> = {
  name: "image-post-image-speechless",
  description: `生成你们怎么不说话了表情包

你们怎么不说话了？是不是都在偷偷玩Uapi，求求你们不要玩Uapi了

## 使用须知
- **响应格式**：接口成功时直接返回 \`image/png\` 格式的二进制数据。
- **文字内容**：至少需要提供 \`top_text\`（上方文字）或 \`bottom_text\`（下方文字）之一。
- **梗图逻辑**：上方描述某个行为，下方通常以「们」开头表示劝阻，形成戏谑的对比效果。`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await imagePostImageSpeechless(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
